import React from 'react';
import './CampaignEnded.css';

const CampaignEnded: React.FC = () => {
  return (
    <div className="campaign-ended">
      <div className="campaign-ended__content">
        <div className="campaign-ended__icon">🏁</div>
        <h1 className="campaign-ended__title">Акция завершена</h1>
        <p className="campaign-ended__message">
          К сожалению, эта акция уже закончилась. 
          Спасибо за участие!
        </p>
        <div className="campaign-ended__footer">
          <p>Следите за новыми акциями!</p>
        </div>
      </div>
    </div>
  );
};

export default CampaignEnded;
